import React, { useState } from 'react';
import { Box, Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTheme } from "@mui/material/styles";
import AgreementTemplates from './Agreement/AgreementTemplates';
import AgreementForm from './Agreement/AgreementForm';
import AgreementMasterTable from './Agreement/AgreementMasterTable';
import AgreementImageConfig from './Agreement/AgreementImageConfig';

const AgreementSettingsLandingPage = () => {
    const theme = useTheme();
    const [currentMode, setCurrentMode] = useState("grid");
    const [data, setData] = useState("");
    const [expanded, setExpanded] = useState("Organization Name");

    const handleChange = panel => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const actionSummaryStyle = {
        minHeight: 50,
        maxHeight: 50,
        borderRadius: "10px 10px 0px 0px",
        '&.Mui-expanded': {
            minHeight: 50,
            maxHeight: 50,
            backgroundColor: theme?.palette?.primary?.dark,
            color: "white",
        }
    };

    const masterSections = [
        { name: "Default Commission", masterType: "commission", hasValueField: true, valueLabel: "Value (%)" },
        { name: "Default Fee Basis", masterType: "fee_basis", hasValueField: false },
        { name: "Default Replacement Period", masterType: "replacement_period", hasValueField: true, valueLabel: "Months" },
        { name: "Default Agreement Duration", masterType: "agreement_duration", hasValueField: true, valueLabel: "Months" },
        { name: "Header Images", masterType: "header_image", hasValueField: true },
        { name: "Footer Images", masterType: "footer_image", hasValueField: true }
    ];





    if (currentMode !== "grid") {
        return (
            <Box sx={{ width: '100%', padding: "0px 10px 25px 10px" }}>
                <AgreementForm setCurrentMode={setCurrentMode} currentMode={currentMode} setData={setData} data={data} />
            </Box>
        );
    }

    return (
        <Box sx={{ width: '100%', padding: "0px 10px 25px 10px" }}>
            {/* Agreement Templates Section */}
            <AgreementTemplates setCurrentMode={setCurrentMode} setData={setData} data={data} />

            <Divider sx={{ my: 3 }} />

            {/* Agreement Master Configuration Section */}
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
                Agreement Configuration Masters
            </Typography>

            <Box>
                {masterSections.map((sec, idx) => (
                    <Accordion
                        key={idx}
                        expanded={expanded === sec.name}
                        onChange={handleChange(sec.name)}
                        sx={{ borderRadius: "10px", mb: 1 }}
                    >
                        <AccordionSummary
                            sx={actionSummaryStyle}
                            expandIcon={<KeyboardArrowDownIcon />}
                            id={`accordion-header-${idx}`}
                            aria-controls={`accordion-content-${idx}`}
                        >
                            <Typography
                                sx={{ color: theme.palette.primary.contrastText }}
                                variant='body1'
                                fontWeight={600}
                            >
                                {sec.name}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {sec.masterType === "header_image" || sec.masterType === "footer_image" ? (
                                <AgreementImageConfig
                                    masterType={sec.masterType}
                                    label={sec.name}
                                />
                            ) : (
                                <AgreementMasterTable
                                    masterType={sec.masterType}
                                    title={sec.name}
                                    hasValueField={sec.hasValueField}
                                    valueLabel={sec.valueLabel}
                                />
                            )}
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Box>
        </Box>
    );
};

// Simple Divider wrapper for neat CSS divider
const Divider = ({ sx }) => <Box sx={{ borderBottom: "1px solid #e0e0e0", ...sx }} />;

export default AgreementSettingsLandingPage;
